module.exports = __webpack_public_path__ + "static/img/026惠企惠民政策1稿.43e8d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/026惠企惠民政策1稿.jpg
// module id = Gz46
// module chunks = 0